// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"2147":"c226d5fd","2855":"4b8dca0c","2873":"d475b68b","3582":"8b796e10","6672":"b4898151","6909":"c226d5fd","8241":"2b0c422c","9218":"88a8ba02"}[chunkId] + ".css";
};